import React, { useState } from 'react';
import LandingNav from '../components/LandingNav';
import HeroSection from '../components/HeroSection';
import EpisodeCountdown from '../components/EpisodeCountdown';
import SocialProofBar from '../components/SocialProofBar';
import CommunitySection from '../components/CommunitySection';
import EpisodesSection from '../components/EpisodesSection';
import GuestHighlightsSection from '../components/GuestHighlightsSection';
import AboutAprilSection from '../components/AboutAprilSection';
import SponsorsSection from '../components/SponsorsSection';
import FinalCTASection from '../components/FinalCTASection';
import Footer from '../components/Footer';
import VideoModal from '../components/VideoModal';

const LandingPage = () => {
  const [selectedVideoId, setSelectedVideoId] = useState(null);

  return (
    <>
      <LandingNav />
      <main>
        <HeroSection onWatchTrailer={() => setSelectedVideoId('iO-bL-QoK0I')} />
        <SocialProofBar />
        <EpisodeCountdown />
        <CommunitySection />
        <EpisodesSection onOpenVideo={setSelectedVideoId} />
        <AboutAprilSection />
        <SponsorsSection />
        <FinalCTASection />
      </main>
      <Footer />

      {/* Video Modal */}
      <VideoModal 
        videoId={selectedVideoId} 
        open={!!selectedVideoId}
        onClose={() => setSelectedVideoId(null)}
      />
    </>
  );
};

export default LandingPage;
